import PropTypes from 'prop-types'
import { useMemo } from 'react'
import cn from 'classnames'
import { createUseStyles } from '../helpers/createStyles'
import { theme } from '../styles/theme'

import ResponsiveImage from './ResponsiveImage'
import RichContent from './RichContent'
import Button from './Button'

const richContentOptions = { showExternalIcon: false }

const Column = ({ column, className }) => {
  const styles = useStyles()
  const content = useMemo(() => {
    if (column.contentType === 'text') {
      return (
        <>
          {column.content && (
            <RichContent
              className={cn({ [styles.contentWithLink]: column.link })}
              content={column.content}
              options={richContentOptions}
            />
          )}
          {column.link && (
            <Button size='md-lg' link={column.link}>
              {column.link.text}
            </Button>
          )}
        </>
      )
    }

    if (column.contentType === 'image') {
      return <ResponsiveImage image={column.image} showPreview={false} background='transparent' />
    }

    return null
  }, [column])

  return <div className={cn(styles.root, className)}>{content}</div>
}

const useStyles = createUseStyles({
  root: {
    gridColumn: '1 / -1',
    [theme.breakpoints.up('xs')]: {
      gridColumn: 'auto / span 4'
    },
    [theme.breakpoints.up('md')]: {
      gridColumn: 'auto / span 3'
    }
  },
  contentWithLink: {
    marginBottom: theme.spacingPx(5)
  }
})

export const columnProps = {
  contentType: PropTypes.oneOf(['text', 'image', 'empty']).isRequired,
  content: PropTypes.array,
  link: PropTypes.object,
  image: PropTypes.object
}

Column.propTypes = {
  column: PropTypes.shape(columnProps).isRequired,
  className: PropTypes.string
}

export default Column
